// =============================
// USER ACKNOWLEDGMENT ACTION TYPES
// =============================

export const  SET_ACCEPTED_POLICIES = " SET_ACCEPTED_POLICIES";
export const ADD_ACCEPTED_POLICY = "ADD_ACCEPTED_POLICY";
export const UPDATE_ACCEPTED_POLICY = "UPDATE_ACCEPTED_POLICY";
